export default __webpack_public_path__ + "static/media/three-dottes-icon.3e107f2d.svg";